import axios from 'axios';
import { Constantes } from '../common/constantes';

const api = axios.create({
  baseURL: `${Constantes.HOST_ASSETS}/api/`,
});

export default api;
